import  { useState } from "react";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FaArrowRight, FaShieldAlt, FaUsers, FaNetworkWired } from "react-icons/fa";
import Reveal from "./Components/Reveal";

const registryUrl = "/registry";

const heroSlides = [
    {
    src: "/assets/images/cyberbation_2026.jpg",
    alt: "TrustBroker Africa community event",
    kicker: "CyberBastion Africa League",
    caption: "WACREN, in collaboration with the Open CSIRT Foundation and TrustBroker Africa (TBA), invites cybersecurity teams and professionals to join CyberBastion Africa League online information session.",
     href: "https://indico.wacren.net/event/271/",
  },
   {
    src: "/assets/images/collab_2026.jpg",
    alt: "TrustBroker Africa collaboration session",
    kicker: "Collaboration and Training",
    caption: "Connecting trusted teams across Africa through shared practice.",
     href: "https://indico.wacren.net/event/270/",
  },
    {
    src: "/assets/images/image2.png",
    alt: "TrustBroker Africa community event",
    // kicker: "Community Engagement",
    // caption: "Connecting trusted teams across Africa through shared practice.",
  },
  {
    src: "/assets/images/cyber-month.jpg",
    alt: "TrustBroker Africa community activity",
    // kicker: "Community Collaboration",
    // caption: "Connecting trusted teams across Africa through shared practice.",
  },
  {
    src: "/assets/images/slider2.jpg",
    alt: "TrustBroker Africa workshop",
    // kicker: "Training and Exchange",
    // caption: "Building operational capability through workshops and technical engagement.",
  },
  {
    src: "/assets/images/sim3slider.jpeg",
    alt: "TrustBroker Africa exercise session",
    // kicker: "Cyber-Defence Exercises",
    // caption: "Strengthening readiness with realistic scenarios and team coordination.",
  },
];

const introductionText = [
  "TrustBroker Africa (TBA) is a pan-African cybersecurity collaboration community connecting security and incident response teams across the continent.",
  "Through its registry, community collaboration activities, training initiatives, and cyber-defence exercises, TrustBroker Africa supports the development of trusted relationships and operational cybersecurity capabilities across Africa.",
  "TrustBroker Africa operates as the community pillar of the WACREN Cybersecurity & Trust Programme, which brings together collaboration communities, professional training initiatives, cyber-defence exercises, and sectoral threat intelligence sharing.",
  "Together these initiatives contribute to strengthening cybersecurity resilience across Africa's research, education, and digital infrastructure ecosystems.",
];

const quickFacts = [
  { value: "13", label: "Registered teams" },
  { value: "11", label: "Countries represented" },
  { value: "4", label: "Capability tracks" },
];

const mapLocations = [
  { name: "Gambia", teams: 1, left: "10%", top: "44%" },
  { name: "Sierra Leone", teams: 1, left: "20%", top: "44%" },
  { name: "Ghana", teams: 2, left: "30%", top: "44%" },
  { name: "Togo", teams: 1, left: "35%", top: "46%" },
  { name: "Benin", teams: 1, left: "39%", top: "45%" },
  { name: "Uganda", teams: 1, left: "56.5%", top: "49%" },
  { name: "Kenya", teams: 2, left: "64%", top: "54%" },
  { name: "Mozambique", teams: 1, left: "66%", top: "77%" },
  { name: "Botswana", teams: 1, left: "48.5%", top: "82%" },
  { name: "South Africa", teams: 1, left: "49%", top: "93%" },
  { name: "Reunion", teams: 1, left: "88%", top: "80%" },
];

const ecosystemHighlights = [
  "Community collaboration",
  "Cybersecurity training",
  "Cyber-defence exercises",
  "Trusted threat intelligence sharing",
];

const initiatives = [
  {
    title: "TrustBroker Africa Community Event 2026",
    meta: "Abuja, Nigeria",
    date: "18–22 May 2026",
    description:
      "The TrustBroker Africa community event brings together cybersecurity professionals from across Africa for training workshops, collaboration sessions, and cyber-defence exercises.",
  },
  {
    title: "CyberBastion Africa League",
    description:
      "CyberBastion provides cyber-defence simulation environments where teams practise responding to realistic cyber incidents and strengthen operational security capabilities.",
  },
  {
    title: "WACREN ISAC Development",
    meta: "Threat Intelligence Sharing",
    description:
      "WACREN is establishing a sectoral Information Sharing and Analysis Centre (ISAC) to support trusted cyber threat intelligence sharing across research and education networks.",
  },
];

const overviewCards = [
  {
    title: "Trusted Registry",
    description:
      "A directory of organisations responsible for coordinating incident response within their institutions and national ecosystems.",
    icon: FaShieldAlt,
  },
  {
    title: "Community Network",
    description:
      "A space for teams, experts, and practitioners to build trusted working relationships across Africa.",
    icon: FaUsers,
  },
  {
    title: "Operational Programme",
    description:
      "Training, exercises, and intelligence-sharing activity connected through the broader WACREN Cybersecurity & Trust Programme.",
    icon: FaNetworkWired,
  },
];

const sectionShell =
  "overflow-hidden rounded-[36px] border border-[#d8dde2] bg-[#f5f8fb] px-6 py-8 shadow-panel backdrop-blur md:px-8 md:py-10";
// const labelClass =
//   "text-xs font-semibold uppercase tracking-[0.22em] text-brand-500 md:text-sm";

function HeroSlider() {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 700,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4200,
    pauseOnHover: true,
  };

  return (
    <div className="tba-hero-slider overflow-hidden rounded-[30px] border border-white/15 bg-[#062943] p-3 shadow-float">
      <Slider {...settings}>
        {heroSlides.map((slide) => (
          <div key={slide.src}>
            <div className="relative overflow-hidden rounded-[24px]">
              <img
                src={slide.src}
                alt={slide.alt}
                className="h-[320px] w-full object-cover md:h-[460px]"
              />
            
              <div className="absolute left-5 top-5 rounded-full border border-white/20 bg-white/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.24em] text-[#eef7fd] backdrop-blur md:left-6 md:top-6">
                {slide.kicker}
              </div>
               {slide.caption && (
               
             <div className="absolute inset-x-4 bottom-4 p-2 text-left text-white  md:inset-x-6 md:bottom-6 md:p-2">
                <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
                  {/* <p className="m-0 max-w-2xl text-base leading-7 text-slate-100 md:text-xl md:leading-8">
                    {slide.caption}
                  </p> */}
                  {slide.href ? (
                    <a
                      href={slide.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 self-end ml-auto rounded-full bg-white px-4 py-2 text-sm font-semibold text-[#05243c] no-underline transition duration-300 hover:-translate-y-0.5 hover:bg-[#e8f3fb]"
                    >
                      Visit event page
                      <FaArrowRight className="text-sm" />
                    </a>
                  ) : null}
                </div>
              </div>
               )}
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

function RegistryMap() {
  const [activeLocation, setActiveLocation] = useState(null);

  return (
    <div className="rounded-[30px] bg-white p-5 text-ink-900 shadow-float backdrop-blur md:p-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="m-0 text-xs font-semibold uppercase tracking-[0.2em] text-[#0477c6]">
            Live Registry Footprint
          </p>
          <h3 className="mb-0 mt-2 text-2xl font-semibold leading-tight text-ink-900">
            Registered teams across Africa
          </h3>
        </div>
        <div className="inline-flex w-fit items-center rounded-full border border-[#d8dde2] bg-[#f3f3f2] px-4 py-2 text-sm font-semibold text-[#0a4f80]">
          13 teams in 11 countries
        </div>
      </div>

      <div className="mt-6 space-y-5">
        <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
          {mapLocations.map((team) => (
            <div
              key={team.name}
              className={`rounded-2xl border px-4 py-3 text-left shadow-sm transition duration-200 ${
                activeLocation === team.name
                  ? "border-[#7fb8dd] bg-[#eef7fd]"
                  : "border-[#d8dde2] bg-white/80"
              }`}
              onMouseEnter={() => setActiveLocation(team.name)}
              onMouseLeave={() => setActiveLocation(null)}
            >
              <div className="flex items-start gap-3">
                <span className="mt-1 inline-flex h-3.5 w-3.5 rounded-full bg-[#0477c6]" />
                <div>
                  <p className="m-0 text-sm font-semibold text-ink-900 md:text-base">
                    {team.name}
                  </p>
                  <p className="m-0 text-sm text-slate-600">
                    {team.teams} team{team.teams > 1 ? "s" : ""}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* <div className="relative mx-auto aspect-[261/278] w-full max-w-[520px] rounded-[28px] bg-gradient-to-br from-brand-50 via-sky-100 to-white p-4">
          <div className="absolute inset-0 rounded-[28px] bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.95),_rgba(237,244,251,0.4)_55%,_rgba(217,235,225,0.35))]" />
          <img
            src="/assets/images/africa-blank.svg"
            alt="Map of Africa showing TrustBroker Africa registry locations"
            className="absolute inset-0 h-full w-full object-contain px-4 py-4 opacity-95 [filter:drop-shadow(0_20px_30px_rgba(11,34,54,0.12))]"
          />
          {mapLocations.map((team) => (
            <div
              key={team.name}
              className="absolute -translate-x-1/2 -translate-y-1/2"
              style={{ left: team.left, top: team.top }}
            >
              <button
                type="button"
                aria-label={`${team.name}: ${team.teams} member team${
                  team.teams > 1 ? "s" : ""
                }`}
                onMouseEnter={() => setActiveLocation(team.name)}
                onMouseLeave={() => setActiveLocation(null)}
                onFocus={() => setActiveLocation(team.name)}
                onBlur={() => setActiveLocation(null)}
                onClick={() =>
                  setActiveLocation((current) =>
                    current === team.name ? null : team.name
                  )
                }
                className="relative flex h-7 w-7 items-center justify-center rounded-full border-0 bg-sky-700 p-0 text-[10px] font-semibold text-white shadow-lg shadow-sky-900/25 transition duration-200 hover:scale-105 focus:scale-105 focus:outline-none focus:ring-4 focus:ring-sky-200"
              >
                <span className="absolute inset-0 animate-soft-pulse rounded-full bg-sky-700/30" />
                <span className="relative z-10">{team.teams}</span>
              </button>

              {activeLocation === team.name ? (
                <div className="pointer-events-none absolute left-1/2 top-[-10px] z-20 min-w-[140px] -translate-x-1/2 -translate-y-full rounded-2xl bg-slate-950 px-3 py-2 text-left text-white shadow-xl">
                  <p className="m-0 text-sm font-semibold">{team.name}</p>
                  <p className="m-0 text-xs text-slate-200">
                    {team.teams} member team{team.teams > 1 ? "s" : ""}
                  </p>
                </div>
              ) : null}
            </div>
          ))}
        </div> */}
      </div>
    </div>
  );
}

function Home() {
  return (
    <div className="tba-homepage mx-auto max-w-[1380px] space-y-8 pb-8 text-ink-900 md:space-y-10">
      <Reveal
        as="section"
        className="tba-home-hero relative overflow-hidden rounded-[40px] bg-[#05243c] p-1 shadow-panel"
      >
        <div className="relative overflow-hidden rounded-[38px] bg-[#0477c6] px-4 py-4 md:px-5 md:py-5">
          <div className="absolute -left-24 top-20 h-56 w-56 rounded-full bg-white/6 blur-3xl" />
          <div className="absolute right-0 top-0 h-72 w-72 rounded-full bg-[#848483]/20 blur-3xl" />

          <div className="relative z-10">
            <HeroSlider />
          </div>
        </div>
      </Reveal>

      <Reveal as="section" className={sectionShell}>
        <div className="flex flex-col gap-4 text-left md:flex-row md:items-end md:justify-between">
          <div className="max-w-3xl space-y-3">
            {/* <p className={labelClass}>Introduction</p> */}
            <h2 className="m-0 text-3xl font-semibold tracking-tight text-[#0477c6] md:text-4xl">
              TrustBroker Africa
            </h2>
            <p className="m-0 text-base leading-8 text-[#55626d] md:text-lg">
              Connecting security and incident response teams across Africa.
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row md:self-auto">
            <a
              href={registryUrl}
              className="inline-flex items-center gap-2 self-start rounded-full border border-[#d8dde2] bg-[#f3f3f2] px-5 py-3 text-sm font-semibold text-[#0a4f80] no-underline transition duration-300 hover:-translate-y-0.5 hover:bg-[#ececeb] hover:text-[#083f66]"
            >
              View the CSIRT Registry
              <FaArrowRight className="text-sm" />
            </a>
            <Link
              to="/join"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#0477c6] px-5 py-3 text-sm font-semibold text-white no-underline transition duration-300 hover:-translate-y-0.5 hover:bg-[#0367aa] hover:text-white"
            >
              Join the Community
            </Link>
          </div>
        </div>

        <div className="mt-6 space-y-5">
          <div className="rounded-[30px] border border-[#d8dde2] bg-white p-6 shadow-sm md:p-7">
            <div className="space-y-5 text-left">
              {introductionText.map((paragraph, index) => (
                <Reveal
                  key={paragraph}
                  className="text-base leading-8 text-[#55626d] md:text-lg"
                  delay={index * 80}
                >
                  <p className="m-0">{paragraph}</p>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="grid gap-4 lg:grid-cols-3">
            {quickFacts.map((fact, index) => (
              <Reveal
                key={fact.label}
                className="rounded-[24px] bg-[#0477c6] p-5 text-white shadow-sm"
                delay={index * 80}
              >
                <p className="m-0 text-white text-3xl font-bold md:text-4xl">
                  {fact.value}
                </p>
                <p className="mb-0 mt-2 text-base leading-7 text-[#edf6fd]">
                  {fact.label}
                </p>
              </Reveal>
            ))}
          </div>

          <div className="grid items-start gap-5 lg:grid-cols-3">
            {overviewCards.map((card, index) => {
              const Icon = card.icon;

              return (
                <Reveal
                  key={card.title}
                  className="group rounded-[26px] border border-[#d8dde2] bg-white p-6 text-left shadow-[0_16px_40px_rgba(15,23,42,0.06)] transition duration-300 hover:-translate-y-1 hover:border-[#8db8d7] hover:shadow-[0_22px_50px_rgba(4,119,198,0.14)]"
                  delay={index * 90}
                >
                  <div className="flex h-52 flex-col gap-5">
                    <div className="flex items-start justify-between gap-4">
                      <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#eef7fd] text-lg text-[#0477c6] ring-1 ring-[#d8dde2] shadow-sm">
                        <Icon />
                      </span>
                      <span className="inline-flex rounded-full border border-[#d8dde2] bg-[#f3f3f2] px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#6f6f6e]">
                        0{index + 1}
                      </span>
                    </div>

                    <div className="space-y-3">
                      <h3 className="m-0 text-[1.65rem] font-semibold leading-tight text-ink-900 md:text-[1.8rem]">
                        {card.title}
                      </h3>
                      <p
                        className="m-0 max-w-[32ch] text-[15px] leading-7 text-[#55626d] md:max-w-none md:text-base"
                        style={{ textAlign: "left" }}
                      >
                        {card.description}
                      </p>
                    </div>

                    <span className="mt-auto inline-flex h-1.5 w-16 rounded-full bg-[#0477c6] opacity-80" />
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </Reveal>

      <Reveal
        as="section"
        className="overflow-hidden rounded-[36px] bg-[#0a4f80] px-6 py-8 text-white shadow-panel md:px-8 md:py-10"
      >
        <div className="grid gap-8 xl:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)]">
          <div className="space-y-5 text-left">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#e3f1fb] md:text-sm">
              Registry
            </p>
            <h2 className="m-0 text-3xl font-semibold tracking-tight md:text-5xl">
              Trusted Security Teams Across Africa
            </h2>
            <p className="m-0 text-base leading-8 text-[#f3f7fa] md:text-lg">
              TrustBroker Africa connects Computer Security Incident Response
              Teams, Security Operations Centres, Product Security Incident
              Response Teams, and other cybersecurity organisations across the
              continent.
            </p>
            <p className="m-0 text-base leading-8 text-[#f3f7fa] md:text-lg">
              The TrustBroker Africa Registry provides a trusted directory of
              teams responsible for coordinating cybersecurity incident response
              within their organisations and national ecosystems.
            </p>
            <div className="pt-2 flex flex-col gap-3 sm:flex-row">
              <a
                href={registryUrl}
                className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-base font-semibold text-[#0a4f80] no-underline transition duration-300 hover:-translate-y-0.5 hover:text-[#083f66]"
              >
                View the CSIRT Registry
                <FaArrowRight className="text-sm" />
              </a>
                <Link
              to="/join"
                className="inline-flex items-center gap-2 rounded-full bg-[#848483] px-6 py-3 text-base font-semibold text-white no-underline transition duration-300 hover:-translate-y-0.5 hover:bg-[#717170]"
              >
                Join the Registry
                {/* <FaArrowRight className="text-sm" /> */}
              </Link>
            </div>
          </div>

          <Reveal delay={120}>
            <RegistryMap />
          </Reveal>
        </div>
      </Reveal>

      <Reveal as="section" className={sectionShell}>
        <div className="grid items-center gap-8 xl:grid-cols-[minmax(0,0.82fr)_minmax(0,1.18fr)]">
          <div className="space-y-5 text-left">
            {/* <p className={labelClass}>Programme Context</p> */}
            <h2 className="m-0 text-3xl font-semibold tracking-tight text-[#0477c6] md:text-4xl">
              WACREN Cybersecurity &amp; Trust Ecosystem
            </h2>
            <p className="m-0 text-base leading-8 text-[#55626d] md:text-lg">
              TrustBroker Africa operates within the broader WACREN
              Cybersecurity &amp; Trust Programme, which integrates community
              collaboration, cybersecurity training, cyber-defence exercises,
              and trusted threat intelligence sharing across Africa.
            </p>
            <div className="grid gap-3 sm:grid-cols-2">
              {ecosystemHighlights.map((item, index) => (
                <Reveal
                  key={item}
                  className="rounded-2xl border border-[#d8dde2] bg-[#f3f3f2] px-4 py-3 text-sm font-medium text-[#495661] shadow-sm md:text-base"
                  delay={index * 70}
                >
                  {item}
                </Reveal>
              ))}
            </div>
          </div>

          <div className="overflow-hidden rounded-[28px] border border-[#d8dde2] bg-white p-4 shadow-sm">
            <img
              src="/assets/images/diagram.png"
              alt="WACREN Cybersecurity and Trust Programme ecosystem diagram"
              className="mx-auto block h-auto w-full rounded-[22px]"
            />
          </div>
        </div>
      </Reveal>

      <Reveal as="section" className={sectionShell}>
        <div className="space-y-6">
          <div>
            {/* <div className="space-y-3"> */}
              <h2 className="m-0 text-3xl font-semibold tracking-tight text-[#0477c6] md:text-4xl">
                Current initiatives
              </h2>
            {/* </div> */}
            <p className="m-0 max-w-2xl text-base leading-7 text-[#55626d]">
              The TrustBroker Africa community is not just a directory. It is
              part of a wider programme of events, exercises, and operational
              capability development.
            </p>
          </div>

          <div className="grid gap-5 lg:grid-cols-3">
            {initiatives.map((initiative, index) => (
              <Reveal
                as="article"
                key={initiative.title}
                className="flex h-full flex-col rounded-[30px] border border-[#d8dde2] bg-white p-6 text-left shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-float"
                delay={index * 90}
              >
                <div className="flex items-center justify-between gap-4">
                  {initiative.meta ? (
                    <p className="m-0 text-xs font-semibold uppercase tracking-[0.18em] text-[#0477c6]">
                      {initiative.meta}
                    </p>
                  ) : (
                    <span />
                  )}
                  {/* <span className="inline-flex h-10 w-10 items-center justify-center rounded-2xl bg-[#eef7fd] text-sm font-semibold text-[#0477c6]">
                    0{index + 1}
                  </span> */}
                </div>
                <h3 className="mb-0 mt-4 text-2xl font-semibold leading-tight text-ink-900">
                  {initiative.title}
                </h3>
                {initiative.date ? (
                  <p className="mb-0 mt-3 text-sm font-semibold uppercase tracking-[0.12em] text-[#5d6973]">
                    {initiative.date}
                  </p>
                ) : null}
                <p className="mb-0 mt-4 text-base leading-8 text-[#55626d]">
                  {initiative.description}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </Reveal>

    </div>
  );
}

export default Home;
